<tax-page-header titleText="Отключение кассы от ОФД с отключением тарифа"></tax-page-header>
<div class="ui-kit-content-container--with-separators">
  <div class="alert-box" translate>
    <svg-icon key="info"></svg-icon>kkm.action.deregister.sign
  </div>

  <div class="info-box">
    <div class="ui-kit-block-title" translate>kkm.organisation.title</div>
    <div class="ui-kit-layout-columns-2">
      <span translate>organization.full.name</span><span>{{ organization?.title }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>organization.iin-bin</span><span>{{ organization?.inn }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>organization.oked</span><span>{{ organization?.okved }}</span>
    </div>
  </div>

  <div class="info-box">
    <div class="ui-kit-block-title" translate>kkm.info.title</div>
    <div class="ui-kit-layout-columns-2">
      <span translate>transaction.ticket.item.name</span><span>{{ kkm?.internalName }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>kkm.settings.serial.factory.number</span><span>{{ kkm?.serialNumber }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>kkm.settings.model</span><span>{{ kkm?.model }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>kkm.settings.year</span><span>{{ kkm?.year }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>kkm.settings.in.retail.place</span><span>{{ formFields?.retailPlaceTitle }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>retail.place.address</span><span>{{ formFields?.retailPlaceAddress?.fullAddress }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span translate>ticket.kkm.fns.kkm.id</span><span>{{ kkm?.fnsKkmId }}</span>
    </div>
    <div class="ui-kit-layout-columns-2" *ngIf="tariff">
      <span translate>tariffs.selected</span><span>{{ tariff?.name }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span></span>
      <tax-checkbox
        [id]="'rememberMe'"
        name="rememberMe"
        [(ngModel)]="isAgreement"
        labelText="kkm.action.confirmation"
      ></tax-checkbox>
    </div>
  </div>


  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" (click)="back()" data-qa-button="go-back" translate>group.back</button>
    <div>
      <button
        class="button_blue"
        [disabled]="!isAgreement"
        (click)="signSms()"
        translate>sign.by.sms.button
      </button>
      <button *ngIf="data"
        class="button_blue"
        [disabled]="!isAgreement"
        [taxOpenCertificateModal]="{ data: data }"
        (signatureGenerated)="signEds($event)"
        translate>sign.by.eds.button
      </button>
    </div>
  </div>
</div>
